import React from 'react';
import MUISnackbar from '@material-ui/core/Snackbar';
import withStyles from '@material-ui/core/styles/withStyles';

import { withModelProps } from '@agile-actors/client/commons/components/model-props';
import { compose } from '@agile-actors/client/commons/utils';

import { message, opened, closeSnackbar } from './ui-model';
import styles from './style';

type Props = {
  classes: Object,
  anchorOrigin?: Object,
  autoHideDuration?: number,
  message?: string,
  opened: ?boolean,

  closeSnackbar: () => void,
};

const Snackbar = ({
  classes,
  anchorOrigin,
  autoHideDuration,
  message,
  closeSnackbar,
  opened,
  ...rest
}: Props) => {
  const Message = <span id="snackbar-message">{message}</span>;

  return (
    <MUISnackbar
      {...rest}
      anchorOrigin={anchorOrigin}
      open={opened}
      onClose={closeSnackbar}
      autoHideDuration={autoHideDuration || 3000}
      ContentProps={{
        'aria-describedby': 'snackbar-message',
        className: classes.content,
      }}
      className={classes.snackbar}
      message={Message}
    />
  );
};

Snackbar.defaultProps = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
  autoHideDuration: 5000,
  message: '',
};

export default compose(
  withModelProps({ message, opened, closeSnackbar }),
  withStyles(styles),
)(Snackbar);
